import { getInputValue, getMultiSelectValues } from '../../shared/dom.util';
import {
    DWT_DEFRA_SUBMISSIONS_END_DATE_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_FACILITY_CODE_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_RECORD_COUNT_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_START_DATE_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_STATUS_ELEMENT_ID,
    dwtDefraSubmissionStatusCodesFromMultiselectValues,
    resolveDwtDefraSubmissionsRecordCount,
} from '../dwt-defra-submissions.constants';
import type { DwtDefraSubmissionsTaskPaneFilter } from '../models/dwt-defra-submissions.model';

/**
 * Reads DWT - Submissions to DEFRA filter fields from the task pane DOM.
 */
export function readDwtDefraSubmissionsTaskPaneFilterFromDom(): DwtDefraSubmissionsTaskPaneFilter {
    const recordCountRaw = getInputValue(DWT_DEFRA_SUBMISSIONS_RECORD_COUNT_ELEMENT_ID);
    const parsedRecordCount = Number.parseInt(recordCountRaw, 10);
    const startDate = getInputValue(DWT_DEFRA_SUBMISSIONS_START_DATE_ELEMENT_ID);
    const endDate = getInputValue(DWT_DEFRA_SUBMISSIONS_END_DATE_ELEMENT_ID);

    return {
        recordCount: resolveDwtDefraSubmissionsRecordCount(
            Number.isNaN(parsedRecordCount) ? undefined : parsedRecordCount
        ),
        facilityCode: getMultiSelectValues(DWT_DEFRA_SUBMISSIONS_FACILITY_CODE_ELEMENT_ID),
        status: dwtDefraSubmissionStatusCodesFromMultiselectValues(
            getMultiSelectValues(DWT_DEFRA_SUBMISSIONS_STATUS_ELEMENT_ID)
        ),
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
    };
}
